

export const IconMaximizeCustom =
{
    active: true,
    iconMaximizeExpand:"https://cdn.shopify.com/s/files/1/0804/9328/1594/files/Group_53expand_4.svg?v=1691524620",
    iconMaximizeClose :"https://cdn.shopify.com/s/files/1/0804/9328/1594/files/Group_53CONTRAER.svg?v=1691524612",

}
export const ShowMaximizeHeader= false;